/* eslint-disable no-console */
// Web-safe mock for @react-native-firebase/crashlytics
// Provides Firebase crashlytics functionality for web

const mockCrashlytics = () => ({
  // Record errors for crash reporting
  recordError: error => {
    console.log('Firebase Crashlytics: Record error', error);
  },

  // Log custom messages
  log: message => {
    console.log('Firebase Crashlytics: Log message', message);
  },

  // Set user identifier
  setUserId: userId => {
    console.log('Firebase Crashlytics: Set user ID', userId);
  },

  // Set custom key-value pairs
  setAttribute: (key, value) => {
    console.log('Firebase Crashlytics: Set attribute', key, value);
  },

  // Enable/disable crashlytics collection
  setCrashlyticsCollectionEnabled: enabled => {
    console.log('Firebase Crashlytics: Set collection enabled', enabled);
  },
});

export default mockCrashlytics;
